module.exports = __webpack_public_path__ + "img/percentage.7ccb4561.svg";